import React, { Component } from 'react'
import style from './style.module.less'
import { Flex } from 'hljd'
import api from '@api/home'
import actions from './actions'
import auth, { TOP_TIP } from '../auth'

/**
 * 顶部提示条
 */
@auth(TOP_TIP)
export default class extends Component {
  state = {
    data: {}
  }
  async componentDidMount() {
    const { success, data } = await api.getToptilApi()
    let _data = {}
    if (success) {
      _data = data || {}
    }
    this.setState({
      data: _data
    })
  }
  render() {
    const { tip, action } = this.state.data // is_pro   2-旗舰版 4-尊享版
    const { path, text } = actions(action)
    const realPath = path && (typeof path === 'function' ? path() : path)
    return (
      !!tip && (
        <Flex className={style.shopTip}>
          <div className={style.left}>
            <i className={style.icon} />
            {tip}
          </div>
          {realPath && <a href={realPath}>{text}</a>}
        </Flex>
      )
    )
  }
}
